type ActionType<T> = {
  type: string;
  payload?: T;
};

type SignoutActionType = {
  type: "SIGNOUT";
};

interface GenericActionWithPayload<A, P> {
  type: A;
  payload: P;
}

interface GenericAction<A> {
  type: A;
}

interface ImmerActionInput<A, D> {
  action: A;
  draft: D;
}

export type {
  ActionType,
  SignoutActionType,
  GenericActionWithPayload,
  GenericAction,
  ImmerActionInput,
};
